export default __webpack_public_path__ + "static/media/baground.23e06f01.jpg";